import { addMinutes, format, parse } from "date-fns";
import { DateTime } from "luxon";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Scroll from "react-scroll";

import SessionTile from "./SessionTile";

import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";


import { TabPanel } from "@headlessui/react";
import noEventImage from "../../assets/noEventImage.svg";
import { TwButton, TwContainer, TwMainLayout, TwTabContainer } from "../../components/tailwind";
import TwAutocomplete from "../../components/tailwind/TwAutocomplete";
import { useToast } from "../../provider/ToastProvider";
import { clearLoadingData, loadingState, setSectionLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForEvent } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function ScheduleEventList({ navigation, profileFor, title }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const [newDraftEventData, setNewDraftEventData] = useLocalStorage("newDraftEventData");
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  // eslint-disable-next-line no-unused-vars
  const [events, setEvents] = React.useState();
  const [eventDates, setEventDates] = React.useState();
  const [eventDatesRange, setEventDatesRange] = React.useState();
  const [sessions, setSessions] = React.useState([]);
  const [pastSessions, setPastSessions] = React.useState([]);
  const [firstLoad, setFirstLoad] = React.useState(true);
  const [searchVal, setSearchValues] = React.useState('');
  const [classList, setClassList] = React.useState([]);
  const [filterOfDate, setfilterOfDate] = React.useState("Upcoming");

  React.useEffect(() => {
    (async () => {
      dispatch(clearLoadingData());
      setFirstLoad(true);
      setSessions([]);
      setPastSessions([]);
      await getListOfEvents();
      await getListOfEventSchedules("Upcoming");
      await getListOfEventSchedules("Past");
      setFirstLoad(false);
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken, dashboardReduxState.updateSessionComp]);

  const handleSessionClick = async (id, eventData) => {
    addToast(t("myschedule.loadingSessionDetails"));
    const isPckg = eventData.isPackage;
    const config = {
      method: "get",
      url: `${getUrlForEvent()}schedule/get?eventScheduleId=${id}&isPackage=${isPckg}`,
    };
    const request = await axiosInstance(config);
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        // dispatch(dashboardActions.setEventData(eventData));
        dispatch(dashboardActions.setEventId(request.data.data.eventId._id));
        dispatch(dashboardActions.setEventData(request.data.data.eventId));
        dispatch(dashboardActions.setCalendarSessionId(id));
        dispatch(dashboardActions.setEventScheduleId(request.data.data._id));
        dispatch(dashboardActions.setEventScheduleData(request.data.data));
        // dispatch(dashboardActions.setViewSessionPage(true));
        if (request.data.data?.eventStatus == "Published") {
          navigate("/myschedule/detail");
        } else {
          navigate("/myevents/detail");
        }
      }
    }
  };

  const handleDuplicateAnEventClick = async (id, eventData) => {
    // addToast(t("myschedule.loadingSessionDetails"));
    const isPckg = eventData.isPackage;
    const config = {
      method: "get",
      url: `${getUrlForEvent()}schedule/get?eventScheduleId=${id}&isPackage=${isPckg}`,
      // url: `${getUrlForEvent()}list?eventId=${eventData.eventId}&listFor=${userReduxState.businessType}`,
    };
    const request = await axiosInstance(config);
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        let eventData = request.data.data.eventId;
        delete eventData._id
        delete eventData._v
        navigate("/myevents/new", {
          state: {
            from: "duplicateEvent",
            eventData: eventData,
            eventScheduleData: request.data.data,
          },
        });
      }
    }
  };

  const renderSessions = (day, dataList, tab = "all", filterOfDate = "Upcoming") => {
    const dateFormat = "yyyy-MM-dd";
    let data = dataList && Array.isArray(dataList) && dataList.length > 0 ? dataList.filter((item) => (
      tab === "all"
      || (tab === "published" && item.hasOwnProperty("eventStatus") && item.eventStatus === "Published")
      || (tab === "drafts" && item.hasOwnProperty("eventStatus") && item.eventStatus === "Draft")
      || (tab === "cancelled" && item.hasOwnProperty("eventStatus") && item.eventStatus === "Cancelled")
    )) : []
    return (
      <ul className="divide-y-0 divide-gray-100" key={day}>
        {data.length > 0 ? (
          data.map((item, idx) => {
            try {
              const dtStart = DateTime.fromISO(item.eventDate);
              const dtEnd = format(
                addMinutes(dtStart.ts, item.duration || 0),
                "HH:mm"
              );
              let totalSeats = 0;
              if (item.eventPricingList) {
                item.eventPricingList.forEach((pricing) => {
                  if (pricing.hasOwnProperty("capacity")) {
                    totalSeats = parseInt(totalSeats) + parseInt(pricing.capacity);
                  }
                })
              }
              let ticketQty = 0;
              // scheduleClass.scheduleClassBookings
              if (item.scheduleClassBookings && item.scheduleClassBookings.length > 0) {
                item.scheduleClassBookings.map((booking) => {
                  if (booking.status === "Cancelled") {
                    return booking;
                  }
                  if (booking.ticketsBought && booking.ticketsBought.length > 0) {
                    booking.ticketsBought.map((ticket) => {
                      ticketQty = parseInt(parseInt(ticketQty) + parseInt(ticket.bookingQty))
                    })
                  } else {
                    ticketQty = parseInt(ticketQty) + parseInt(booking.capacity ? booking.capacity : 0);
                  }
                })
              }
              const modifiedData = {
                id: item.instanceId,
                imgSrc: item.eventPhoto,
                title: item.eventName,
                time: `${dtStart.toFormat("dd LLL, ccc, HH:mm")} - ${dtEnd}`,
                // time: `${dtStart.toFormat("hh':'mma")} - ${dtEnd}`,
                // venue: `${item.location.houseNumber}, ${item.location.city}`,
                venue: `${item.location.address}`,
                totalSeats: totalSeats,
                seatsBooked: ticketQty,
                seatsBookedPerc: (ticketQty / totalSeats) * 100,
                bookedPeople: item.participants,
                item: item,
              };
              return (
                tab === "all"
                || (tab === "published" && item.hasOwnProperty("eventStatus") && item.eventStatus === "Published")
                || (tab === "drafts" && item.hasOwnProperty("eventStatus") && item.eventStatus === "Draft")
                || (tab === "cancelled" && item.hasOwnProperty("eventStatus") && item.eventStatus === "Cancelled")
              ) ? (
                <SessionTile
                  {...modifiedData}
                  key={idx}
                  handleSessionClick={() => {
                    handleSessionClick(modifiedData.id, item);
                  }}
                  handleDuplicateAnEventClick={async () => {
                    await handleDuplicateAnEventClick(modifiedData.id, item);
                  }}
                  reloadData={async () => {
                    await getListOfEventSchedules(filterOfDate);
                  }}
                />
              ) : "";
            } catch (error) {
              return (<></>);
            }
          })
        ) : (
          <li className={"text-black text-center py-2"}>{t("myschedule.noEventsAvailable")}</li>
        )}
      </ul>
    );
  };

  const getListOfEvents = async () => {
    let mgClasses = [];
    const manageClassesConfig = {
      method: "get",
      url: `${getUrlForEvent()}list?listFor=${userReduxState.businessType}`,
    };
    dispatch(setSectionLoading(true));
    const manageClassesRequest = await axiosInstance(manageClassesConfig);
    dispatch(setSectionLoading(false));
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.data.length) {

        for (const item of manageClassesRequest.data.data) {
          const isPresent = mgClasses.find((d) => d.label === item.eventName)
          if (!isPresent) {
            mgClasses.push({
              label: item.eventName,
              id: item._id,
              data: item
            });
          }
        }
        setClassList(mgClasses);
      }
    }
  };

  const getListOfEventSchedules = async (filterOfDate) => {

    const date = new Date(selectedDate).toISOString();
    const config = {
      method: "get",
      // url: `${getUrlForEvent()}groupScheduledEvent?searchDate=${date}&eventId=`,
      url: `${getUrlForEvent()}groupScheduledEvent?filterOfDate=${filterOfDate.toLowerCase()}`,
    };
    dispatch(setSectionLoading(true));
    const request = await axiosInstance(config);
    dispatch(setSectionLoading(false));
    if (request.status === 200) {
      const allEvents = { ...request.data.data };
      let allEventDates = [];
      const dateFormat = "yyyy-MM-dd";
      const eventDatesRange = { from: "", to: "" };
      const eventKeys = Object.keys(allEvents);
      const startDate = parse(eventKeys[0], dateFormat, new Date());
      const endDate = parse(
        eventKeys[eventKeys.length - 1],
        dateFormat,
        new Date()
      );
      eventDatesRange.from = startDate;
      eventDatesRange.to = endDate;
      eventKeys.forEach((key) => {
        if (allEvents[key].length > 0) {
          const parsedDate = parse(key, dateFormat, new Date());
          allEventDates.push(parsedDate);
        }
      });
      setEventDatesRange({ ...eventDatesRange });
      setEventDates([...allEventDates]);
      setEvents({ ...allEvents });

      let initialSessionsData = { ...allEvents };
      const todayFormated = format(new Date(selectedDate), dateFormat);
      const idxOfTodayInEvents =
        Object.keys(initialSessionsData).indexOf(todayFormated);
      initialSessionsData = Object.fromEntries(
        Object.entries(initialSessionsData).slice(idxOfTodayInEvents)
      );


      // setSessions({ ...initialSessionsData });
      if (filterOfDate == "Past") {
        setPastSessions(request.data.data);
      } else {
        setSessions(request.data.data);
      }
    }
  };

  const onSearchClickHandle = async (eventData) => {
    const dateFormat = "yyyy-MM-dd";
    const newDateFormated = format(new Date(selectedDate), dateFormat);
    const newDate = new Date(selectedDate).toISOString();
    const config = {
      method: "get",
      // url: `${getUrlForEvent()}groupScheduledEvent?searchDate=${newDate}&eventId=${eventData.id}`,
      // url: `${getUrlForEvent()}groupScheduledEvent?filterOfDate=${filterOfDate.toLowerCase()}&eventId=${eventData.id}`,
      url: `${getUrlForEvent()}groupScheduledEvent?filterOfDate=${filterOfDate.toLowerCase()}&searchName=${eventData?.data?.eventName || ""}`,
    };
    const request = await axiosInstance(config);
    let selectedDateSessions;
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        let dataList = request.data.data;
        if(eventData?.data?.eventName){
          
          dataList = request.data.data.filter((f)=> f.eventName == eventData?.data?.eventName);
          // dataList = request.data.data.filter((f)=> f.eventId == eventData?.data?._id);
        }
        setSessions(dataList);
        //     newDateFormated
        // }
      }
    }

    // setSessions({ ...selectedDateSessions });

    const { scroller } = Scroll;
    scroller.scrollTo(newDateFormated, {
      smooth: true,
      containerId: "sessionsPopover",
      delay: 2000,
    });
  };


  return (
    <TwMainLayout
      headTitle={t("pageTitle.myEvents")}
      headActions={[
        (<div className={"flex flex-col-reverse sm:flex-row gap-3 w-full"}>
          <div className={"flex gap-3"}>
            {false && classList.length > 0 && (<TwAutocomplete
              disablePortal
              options={classList}
              // defaultValue={searchVal}
              onChange={async (newValue) => {
                if (newValue) {
                  setSearchValues(newValue.label);
                  onSearchClickHandle(newValue);
                } else {
                  setSearchValues("");
                  onSearchClickHandle({ label: "", id: "", data: {} });
                }
              }}
            />)}
          </div>
          <div className={"flex flex-row items-center gap-3"}>
            {/* <TwSelectGroup
              // label={"Gender"}
              selectClass={"md:!px-3 md:!py-2.5"}
              placeholder={"Select Filter"}
              name={"filterOfDate"}
              leftIcon={(<FunnelIcon aria-hidden="true" className="size-5 [text-primary]" />)}
              options={[
                // { value: "", title: "Select Filter" },
                { value: "Upcoming", title: "Upcoming" },
                { value: "Past", title: "Past" },
              ]}
              value={filterOfDate}
              onChange={(e) => {
                setfilterOfDate(e.target.value)
              }} /> */}
            {/* <TwButton
              className="lg:hidden sm:min-w-32 truncate"
              onClick={() => {
                setNewDraftEventData({});
                navigate("/myevents/new");
              }}
            >
              <PlusIcon className='size-5' />&nbsp;&nbsp;{t("myEvents.createEvent")}
            </TwButton> */}
          </div>
        </div>),
      ]}
      children={
        <TwContainer className="">

          {firstLoad === false && classList.length ? (<div
            className={"[sm:max-w-md md:max-w-lg] w-full"}
          >
            <div className={"flex flex-col"}>
              <div className={"flex flex-col sm:flex-row gap-4 sm:justify-between sm:items-center"}>
                <TwAutocomplete
                  options={classList}
                  // defaultValue={searchVal}
                  onChange={async (newValue) => {
                    if (newValue) {
                      setSearchValues(newValue.label);
                      onSearchClickHandle(newValue);
                    } else {
                      setSearchValues("");
                      onSearchClickHandle({ label: "", id: "", data: {} });
                    }
                  }}
                />
                <div>
                  {/* <TwButton
                    className="!py-3 md:!py-3 xl:!py-3 truncate"
                    onClick={() => {
                      setNewDraftEventData({});
                      navigate("/myevents/new");
                    }}
                  >
                    <PlusIcon className='size-5' />&nbsp;{t("myEvents.createEvent")}
                  </TwButton> */}
                </div>
              </div>
              <div
                className="w-full">
                <TwTabContainer
                  className=""
                  tabsClassName="border-b px-5 md:px-10"
                  selectedTab={"all"}
                  tabs={[
                    {
                      name: t("myschedule.allTab"), key: 'all', onClick: () => { }, icon: null,

                    },
                    {
                      name: t("myschedule.publishedTab"), key: 'published', onClick: () => { }, icon: null,
                    },
                    {
                      name: t("myschedule.draftsTab"), key: 'drafts', onClick: () => { }, icon: null,
                    },
                    {
                      name: t("myschedule.cancelledtab"), key: 'cancelled', onClick: () => { }, icon: null,
                    },
                    {
                      name: t("myschedule.pastTab"), key: 'cancPastelled', onClick: () => { }, icon: null,
                    },
                  ]}
                >
                  <TabPanel key={"all"}>
                    <div className="">
                      {renderSessions("all", sessions, "all")}
                    </div>
                  </TabPanel>
                  <TabPanel key={"published"}>
                    <div className="">
                      {renderSessions("published", sessions, "published")}
                    </div>
                  </TabPanel>
                  <TabPanel key={"drafts"}>
                    <div className="">
                      {renderSessions("drafts", sessions, "drafts")}
                    </div>
                  </TabPanel>
                  <TabPanel key={"cancelled"}>
                    <div className="">
                      {renderSessions("cancelled", sessions, "cancelled")}
                    </div>
                  </TabPanel>
                  <TabPanel key={"past"}>
                    <div className="">
                      {renderSessions("pastall", pastSessions, "all")}
                    </div>
                  </TabPanel>
                </TwTabContainer>
              </div>
            </div>
          </div>) : (firstLoad === false && loadingReduxState.sectionLoading !== undefined && loadingReduxState.sectionLoading === false) ? (
            <div className="flex flex-col justify-center items-center gap-5 text-center h-full">
              <img
                className={"w-40 md:w-60"}
                src={noEventImage}
                alt={""}
              />
              <div className={"text-secondary text-lg font-bold"}>
                {t("myschedule.noEventsConfigured")}
              </div>
              <div className="flex justify-center items-center w-full">
                <TwButton
                  variant={"secondary"}
                  className={"lg:hidden "}
                  onClick={() => {
                    // setNewDraftEventData({});
                    navigate("/myevents/new");
                  }}
                >
                  {t("myEvents.addNewEvent")}
                </TwButton>
              </div>
            </div>
          ) : ""}
        </TwContainer>}
    />
  );
}
